import { FlexBox, JoonUIColor, SPACING } from "@joonapp/web-shared"
import { useState } from "react"
import { Link, useLocation } from "react-router-dom"

import { useGetMeTabCardQuery } from "../../networking/queries"
import { useCustomRewardBalancesQuery } from "../../networking/rewards/queries"
import UnreadMailNotificationDot from "../../pages/family/UnreadMailNotificationDot"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"
import NotificationDot from "../notificationDot/NotificationDot"

type Props = {
  to: string
  name: string
  Icon: any
}

const NavLink = ({ to, name, Icon }: Props) => {
  const [isHovered, setIsHovered] = useState(false)
  const location = useLocation()
  const { data: meTabCard } = useGetMeTabCardQuery()
  const { data: rewardBalances } = useCustomRewardBalancesQuery()

  const showRewardsNotificationDot =
    to === "/rewards" &&
    rewardBalances !== undefined &&
    rewardBalances.length > 0
  const showUnreadCoachMessageNotificationDot =
    (to === "/care" || to === "/coach") && !!meTabCard?.unread_message?.message

  const isOnDefaultPage = location.pathname === "/" && to === "/me"
  const isOnCoachPage =
    "/" + location.pathname.split("/")[1] === "/coach" && to === "/care"
  const isActive =
    "/" + location.pathname.split("/")[1] === to ||
    isOnDefaultPage ||
    isOnCoachPage

  return (
    <Link
      to={to}
      onClick={() =>
        trackAnalyticEvent(ANALYTIC_EVENTS.NAV_ITEM_CLICK, { page: name })
      }
      style={{ width: "100%" }}
    >
      <div className={to === "/care" ? "tour-step-1" : ""}>
        <div
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            fontSize: "16px",
            padding: `${SPACING.space4} ${SPACING.space4}`,
            alignItems: " center",
            display: "flex",
            whiteSpace: "nowrap",
            textDecoration: "none !important",
            margin: `0 ${SPACING.space2}`,
            borderRadius: "16px",
            color: isActive
              ? JoonUIColor.text.inverted
              : JoonUIColor.text.primary,
            fontWeight: isActive ? "500" : "400",
            background: isActive
              ? `radial-gradient(
                155.78% 153.07% at 101.11% -5.68%,
                rgba(255, 255, 255, 0.4) 0%,
                rgba(255, 255, 255, 0) 100%
              ),
              radial-gradient(
                231% 135.8% at 0.9% 2.98%,
                rgba(255, 255, 255, 0.16) 0%,
                rgba(255, 255, 255, 0) 100%
              ), ${JoonUIColor.semantic.primary}`
              : isHovered
                ? JoonUIColor.background.lightAccent
                : "inherit",
          }}
        >
          <FlexBox
            align="center"
            justify="center"
            style={{
              position: "relative",
              width: "fit-content",
              height: "fit-content",
              marginRight: SPACING.space4,
            }}
          >
            <Icon
              color={
                isActive
                  ? JoonUIColor.text.inverted
                  : JoonUIColor.text.secondary
              }
              size={24}
            />
            {to === "/family" && <UnreadMailNotificationDot size="7px" />}
            {showRewardsNotificationDot && (
              <NotificationDot position="top-right" />
            )}
            {showUnreadCoachMessageNotificationDot && (
              <NotificationDot position="top-right" />
            )}
          </FlexBox>
          {name}
        </div>
      </div>
    </Link>
  )
}

export default NavLink
